import React from 'react';
import { CmsHelpPageCategory } from '../../integrations/contentful/types';
import { baseXInPixels, baseXUnit, linkStyle } from '../../styles/theme';
import H from '../elements/H';
import Paragraph from '../elements/Paragraph';
import RouteLink from '../navigation/RouteLink';
import { Paths } from '../../urls/Paths';
import CmsMedia from '../cms/CmsMedia';
import HyperLink from '../elements/HyperLink';

interface HelpCategoryItemProps {
  helpCategory: CmsHelpPageCategory;
}

const imageSize = baseXInPixels(12);
const HelpCategoryItem: React.FunctionComponent<HelpCategoryItemProps> = ({
  helpCategory
}) => {
  return (
    <div>
      <RouteLink
        path={Paths.HelpCategory}
        params={{
          slug: helpCategory.fields.slug
        }}
      >
        <HyperLink noLinkStateStyles>
          <div className="help-category-item" data-testid="help-category-item">
            {helpCategory.fields.image && (
              <div className="help-category-image-wrapper">
                <CmsMedia
                  media={helpCategory.fields.image}
                  height={imageSize}
                  width={imageSize}
                  borderRadius={1}
                />
              </div>
            )}
            <div className="text-content">
              <H styling="h3">
                <strong className="title">{helpCategory.fields.title}</strong>
              </H>
              <Paragraph tag="div">{helpCategory.fields.label}</Paragraph>
            </div>
          </div>
        </HyperLink>
      </RouteLink>
      {/*language=CSS*/}
      <style jsx>{`
        .help-category-item {
          display: flex;
        }
        .help-category-item .title {
          ${linkStyle.withAnimation}
        }
        .help-category-item:hover .title {
          ${linkStyle.hover}
        }
        .help-category-item:active .title {
          ${linkStyle.active}
        }
        .help-category-image-wrapper {
          max-width: ${imageSize}px;
        }
        .text-content {
          margin-left: ${baseXUnit(2)};
          padding-top: ${baseXUnit(2)};
        }
      `}</style>
    </div>
  );
};

export default HelpCategoryItem;
